fpUi.Category = fp.Component.extend({
    construct: function (element, config, template, parent) {
        template = template || fpUi.getTemplate('component/0/category.html');

        this._super(element, config, template, parent);

        _.defaults(this.config, {
            replaceElement: true,
            autoRenderMaxDepth: 0
        });

        if (fpUi.router.routeManager.urlParams.render_child_categories == 'true') {
            this.config.autoRenderMaxDepth = -1;
        }
    },

    render: function (params) {
        // Initialize hashedItems to store category items
        this.scope.hashedItems = {};
        this._super(params);

        var self = this,
            scope = this.scope,
            hashedItems = scope.hashedItems;

        // Bind click and keypress events to both <a> tags and <button> elements
        this.$element.on('click keypress', 'a, .fp-nav-item-icon', function (event) {
            var $target = $(event.target);

            // Detect clicks only on button with `.fp-nav-item-icon`
            if (!$target.hasClass('fp-nav-item-icon')) {
                return;
            }

            event.preventDefault();

            var $parent = $target.closest('.fp-has-children'),
                $ul = $parent.children('ul.fp-nav'),
                id = $parent.find('a').attr('data-id');

            if (self.config.autoRenderMaxDepth > -1 && !$ul.length && !$parent.hasClass('fp-is-selected')) {
                var item = hashedItems[id];

                if (item && _.size(item.items)) {
                    $ul = $(fpUi.renderTemplate(self.config.template, $.extend({}, scope, {
                        items: item.items,
                        level: fpUtil.getInteger($parent.find('a').attr('data-depth')) + 1
                    }))).appendTo($parent);
                }
            }

            if (event.type === 'click' || (event.type === 'keypress' && event.key === 'Enter')) {
                $parent.toggleClass('fp-is-expanded');
                $parent.hasClass('fp-is-expanded')
                    ? $target.attr('aria-expanded', 'true')
                    : $target.attr('aria-expanded', 'false');

                if ($ul.length) {
                    if ($parent.hasClass('fp-is-expanded')) {
                        $ul.stop(true, true).slideDown(300);
                    } else {
                        $ul.stop(true, true).slideUp(300);
                    }
                }
            }
        });
    }
});
